// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : INACTIVE MEMBER REPORT
// MODIFIED DATE: 29-09-2025

const InActiveMemberActionTypes = {
	/*********** GET INACTIVE MEMBER LIST START *********************** */
	GET_INACTIVE_MEMBER_LIST_START: 'get_inactive_member_start',
	GET_INACTIVE_MEMBER_LIST_SUCCESS: 'get_inactive_member_success',
	GET_INACTIVE_MEMBER_LIST_FAILURE: 'get_inactive_member_failure',
	GET_INACTIVE_MEMBER_LIST_RESPONSE_RESET: 'get_inactive_member_response_reset',
	GET_INACTIVE_MEMBER_LIST_RESPONSE_CHANGED: 'get_inactive_member_response_changed',
	/*********** GET INACTIVE MEMBER LIST END *********************** */
};
export default InActiveMemberActionTypes;
